import { render } from "./OrdinanceForm.vue?vue&type=template&id=20dea1aa"
import script from "./OrdinanceForm.vue?vue&type=script&lang=ts"
export * from "./OrdinanceForm.vue?vue&type=script&lang=ts"
script.render = render

export default script